import Glide from '@glidejs/glide';
import { settings as raySettings } from '@wework/ray-core';
import { trackSliderInteraction } from './analytics';

const PREVIOUS_ARROW_SELECTOR = '.slider__arrow-btn--left';
const NEXT_ARROW_SELECTOR = '.slider__arrow-btn--right';
export const RESPONSIVE_GLIDE_SETTINGS = {
  gap: 24,
  breakpoints: {
    [raySettings.breakpointsInPixels.tablet]: {
      gap: 8
    },
    [raySettings.breakpointsInPixels.desktop]: {
      gap: 24
    }
  }
};

export default class WeGlide {
  constructor(selector, overrides) {
    const settings = {
      ...RESPONSIVE_GLIDE_SETTINGS,
      ...overrides
    };

    this.element = document.querySelector(selector);
    this.glide = new Glide(selector, settings);
    this.previousArrow = this.element.querySelector(PREVIOUS_ARROW_SELECTOR);
    this.nextArrow = this.element.querySelector(NEXT_ARROW_SELECTOR);

    this.hidePreviousArrowOnFirstSlide();
    this.trackArrowsClickInteractions();
    this.trackSwipeInteractions();
  }

  hidePreviousArrowOnFirstSlide() {
    if (!this.previousArrow) return;

    this.glide.on('move', ({ movement }) => {
      const isFirstSlide = movement === 0;
      if (isFirstSlide) {
        this.previousArrow.classList.add('hidden');
      } else {
        this.previousArrow.classList.remove('hidden');
      }
    });
  }

  trackArrowsClickInteractions() {
    if (this.nextArrow) {
      this.nextArrow.addEventListener('click', () => {
        trackSliderInteraction(this.sliderName, this.glide.index + 1, 'arrow');
      });
    }

    if (this.previousArrow) {
      this.previousArrow.addEventListener('click', () => {
        trackSliderInteraction(this.sliderName, this.glide.index - 1, 'arrow');
      });
    }
  }

  trackSwipeInteractions() {
    this.glide.on('swipe.end', () => {
      trackSliderInteraction(this.sliderName, this.glide.index, 'swipe');
    });
  }

  mount() {
    this.glide.mount();
  }

  destroy() {
    this.glide.destroy();
  }

  get sliderName() {
    return this.element.dataset.name;
  }
}
